import { render } from "./GeographicDataView.vue?vue&type=template&id=9761696c&scoped=true"
import script from "./GeographicDataView.vue?vue&type=script&lang=js"
export * from "./GeographicDataView.vue?vue&type=script&lang=js"

import "./GeographicDataView.vue?vue&type=style&index=0&id=9761696c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9761696c"]])

export default __exports__